<template>
    <input type="text"
           :value="value"
           name="validityDate"
           ref="input"
           placeholder="GG-MM-YYYY"
    >
</template>

<script>
    import Pikaday from 'pikaday';
    import "pikaday/css/pikaday.css"

    export default {
        props: {
            value: { required: true },
            format: { default: 'DD-MM-YYYY' },
            options: { default: {} }
        },

        mounted() {
            const picker = new Pikaday({
                field: this.$refs.input,
                format: this.format,
                onSelect: () => {
                    this.$emit('input', picker.toString())
                },
                ...this.options
            });
        }

    }
</script>
